var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"footer"},[_c('li',{on:{"click":_vm.toIndex}},[_c('i',{staticClass:"fa fa-home"}),_c('p',[_vm._v("首页")])]),_vm._m(0),_c('li',{on:{"click":_vm.toOrderList}},[_c('i',{staticClass:"fa fa-file-text-o"}),_c('p',[_vm._v("订单")])]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('i',{staticClass:"fa fa-compass"}),_c('p',[_vm._v("发现")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('i',{staticClass:"fa fa-user-o"}),_c('p',[_vm._v("我的")])])
}]

export { render, staticRenderFns }